import { LogoMark } from "./Logo";

const Mark = ({ className = "h-5 w-5" }) => (
  <img src="/mark.png" alt="" aria-hidden="true" className={`${className} object-contain opacity-70`} />
);

const ITEMS = [
  "Turnkey Sim Racing",
  "Trade Show Booths",
  "Brand Activations",
  "Corporate Events",
  "Leaderboard Competitions",
  "Nationwide Delivery",
];

export const Marquee = () => (
  <div
    className="relative border-y border-line bg-panel/40 py-6 overflow-hidden"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="flex whitespace-nowrap animate-marquee-x w-max">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
              <span
                className={`font-display text-2xl sm:text-3xl font-black uppercase tracking-tight px-8 ${
                  i % 2 ? "text-electric" : "text-slate-200"
                }`}
              >
                {item}
              </span>
              <Mark className="h-5 w-auto" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
